/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.geometric-shapes\":\"Neliö, ympyrä, vinoneliö ja kolmio\"}");